import 'nprogress/nprogress.css';// Progress 进度条样式

import Cookie from 'js-cookie';
import NProgress from 'nprogress'; // Progress 进度条

import router from './router';

// code 工资条带邀请码注册页面
//down 企业中心发票下载
const whiteList = ['/login', '/interpage','/about', '/modifyAbout','/hrModifyAbout', "/code", '/down','/hrAbout','/helpcenter'] // 不重定向白名单

router.beforeEach((to, from, next) => {
  NProgress.start()
  let token = Cookie.get('token') ? Cookie.get('token') : '';
  if (token) {
    window.sessionStorage.setItem('token',token);
    if (to.path == '/login' || to.path == '/') {
      next('/index')
    }else{
      document.title = to.meta.title||'悦享工资条';
      next()
      NProgress.done()
    }
  } else {
    whiteList.indexOf(to.path)
    if (whiteList.indexOf(to.path) !== -1) {
      document.title = to.meta.title||'悦享工资条';
      next();
      NProgress.done();
    }else if(to.path=='/'){
      next('/interpage')
      NProgress.done();
    } else {
      next('/login')
      NProgress.done();
    }
  }
})

router.afterEach(() => {
  NProgress.done() // 结束Progress
})
